<template>
  <li>
      <span class="inp-box">
        <label><input type="checkbox" class="filter-list-check-box" @change="onChangeCheck" v-model="item.checked">
          <span class="filter-list-Label">
            {{ item.itemName }}
          </span>
        </label>
      </span>
    <ul v-if="this.item.child&&this.item.child.length > 0" class="dep">
      <TreeChecker ref="childChecker" v-for="(child, i) in item.child" :item="child" :index="(i+1).toString()" :code="'row-' + index"
                   @checked-update="onChangeCheckFromChild" v-bind:key="i"></TreeChecker>
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeChecker",

  props: {
    item: {
      type: Object,
      default: {}
    },
    index: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
    }
  },
  methods: {
    // 체크박스 상태변경 처리
    updateCheck(value) {
      this.$set(this.item, 'checked', value);
      //this.updateFilter(value);
    },
    updateCheckAll (value) {  // 전체 체크
      this.updateCheck(value);
      this.updateCheckChild(value);
    },
    updateCheckChild (value) {  // 자식 체크 업데이트
      if (this.item.child&&this.item.child.length > 0) {  // 자식이 있을경우 체크박스 상태변경 처리
        this.$refs.childChecker.forEach(child => {
          child.updateCheckAll(value);
        });
      }
    },
    // 체크박스 onChange 이벤트 처리
    onChangeCheck() {
      //this.updateFilter(this.item.checked);
      this.updateCheckChild(this.item.checked); // 자식 체크 상태 업데이트
      this.$emit('checked-update', this.item.checked); // 부모 체크 상태 업데이트
    },
    // 하위 체크박스 이벤트 처리
    onChangeCheckFromChild(value) {
      let checked = false;
      if (this.item.child) {
        this.item.child.forEach(item => {
          if (item.checked)
            checked = true;
        })
      }
      this.$set(this.item, 'checked', checked);
      this.$emit('checked-update'); // 전체 체크 상태 업데이트
    }
  }
}
</script>

<style scoped>
.on-search {
  background-color: yellow;
}
.on-search-selected {
  background-color: orange !important;
}
.filter-list-Label {
  padding: 0 2px;
}
</style>
